<template lang="pug">
div.modal-content-connection

    div.new-connection(v-if="connectionId === null && connectionsList.length > 0")
        div.new-connection-wrapper
            div.l-flex-row
                select.select-connection(
                    v-model="dataFormConnection.id"
                    placeholder="Select an existing connection")
                    option(value="null" disabled hidden) Select an existing connection
                    option(
                        v-for="item in connectionsList",
                        :key="item.id",
                        :label="item.label"
                        :value="item.id"
                    ) {{ item.label }}
                button.btn.btn--round.btn--medium.btn-choose-connection(
                    :class="{'ui-disabled' : buttonIsDisabled}"
                    @click.prevent="chooseConnection") Choose
            p.p-text or
            button.btn.btn--round.btn--medium.btn-new-connection(@click.prevent="displayFormConnection") New connection
    
    template(v-else-if="notReadyIsLoading")
        ScreenLockLoader()
        
    template(v-else)
        div.modal-body
            form.form-connection
                div.l-flex-row.has-gutter_medium
                    div.form-subsection.w-180
                        div.form-label__required
                            label(for="connection-name") Label
                        input.form-input(
                            v-model="dataFormConnection.label"
                            placeholder="Connection label"
                            autofocus
                            id="connection-name"
                            name="connection-name"
                            v-validate="'max:200|required'"
                            type="text")
                        span.form-validate-error {{ errors.first('connection-name') }}

                    div.form-subsection.w-180
                        div.form-label
                            label(for="connection-type") Type
                        select.form-select.big.square.w-180(
                            id="connection-type"
                            name="connection-type"
                            v-model="dataFormConnection.type"
                            placeholder="Select server type")
                            option(
                                v-for="item in optionConnections",
                                :key="item.id",
                                :label="item.label",
                                :value="item.value") {{ item.label }}

                div.l-flex-row.has-gutter_medium
                    div.form-subsection.w-180
                        div.form-label__required
                            label(for="connection-hostname") {{ hostnameTitle }}
                        input.form-input(
                            v-model="dataFormConnection.hostname"
                            :placeholder="hostnamePlaceholder"
                            id="connection-hostname"
                            name="connection-hostname"
                            v-validate="'max:255|required'"
                            type="text")
                        span.form-validate-error {{ errors.first('connection-hostname') }}

                    div.form-subsection.w-180(v-if="dataFormConnection.type === 'sftp' || dataFormConnection.type === 'ftp'" :key="'divPort'")
                        div.form-label__required
                            label(for="connection-port") Port
                        input.form-input(
                            v-model="dataFormConnection.port"
                            placeholder="ex: 22"
                            id="connection-port"
                            name="connection-port"
                            v-validate="'decimal:no|required'"
                            type="text")
                        span.form-validate-error {{ errors.first('connection-port') }}

                    div.form-subsection.w-180(v-if="dataFormConnection.type === 's3'" :key="'divRegion'")
                        div.form-label__required
                            label(for="connection-region") Region
                        input.form-input(
                            v-model="dataFormConnection.region"
                            :placeholder="hostnamePlaceholder"
                            id="connection-region"
                            name="connection-region"
                            v-validate="'max:255|required'"
                            type="text")
                        span.form-validate-error {{ errors.first('connection-region') }}

                div.l-flex-row.has-gutter_medium(v-if="dataFormConnection.type === 'sftp'" :key="'divSftpPwd'")
                    div.form-subsection.w-180.simple
                        div.form-label
                            label Authentication by
                        div.l-flex-row--between.l-align-center
                            div.form-radio-item.form-radio-item--left
                                input(type="radio" id="sftp_pwd" value="sftp_pwd" v-model="dataFormConnection.sftpType")
                                label(for="sftp_pwd") Password
                            div.form-radio-item.form-radio-item--right
                                input(type="radio" id="sftp_key" value="sftp_key" v-model="dataFormConnection.sftpType")
                                label(for="sftp_key") Key

                div(v-if="dataFormConnection.type !== 'gcloud'" :key="'divGcloud'")
                    div.l-flex-row.has-gutter_medium
                        div.form-subsection.w-180
                            div.form-label__required
                                label(for="connection-username") {{ username }}
                            input.form-input(
                                v-model="dataFormConnection.username"
                                :placeholder="username"
                                id="connection-username"
                                name="connection-username"
                                v-validate="'max:255|required'"
                                type="text")
                            span.form-validate-error {{ errors.first('connection-username') }}

                        div.form-subsection.w-180(v-if="dataFormConnection.sftpType !== 'sftp_key'|| dataFormConnection.type === 'ftp'" :key="'divPwd'")
                            div(:class="classPasswordRequest")
                                label(for="connection-password") {{ password }}
                            input.form-input(
                                v-model="dataFormConnection.password"
                                :placeholder="password"
                                id="connection-password"
                                name="connection-password"
                                v-validate="passwordRules"
                                :type="passwordType")
                            span.form-validate-error {{ errors.first('connection-password') }}

                            div.form-subsection-row.form-input-extra
                                input(
                                    id="display-password"
                                    name="display-password"
                                    v-model="displayPassword"
                                    type="checkbox")
                                label(for="display-password") display {{ password.toLowerCase() }}

                        div.form-subsection.w-180(v-if="dataFormConnection.type === 'sftp' && dataFormConnection.sftpType === 'sftp_key'"  :key="'divSsh'")
                            div.form-subsection
                                div(:class="classPasswordRequest")
                                    label(for="connection-connector_key") SSH private key
                                    //-max length 9
                                textarea.form-input(
                                    v-model="dataFormConnection.connector_key"
                                    placeholder="SSH private key"
                                    id="connection-connector_key"
                                    name="connection-connector_key")
                                span.form-validate-error {{ errors.first('connection-connector_key') }}

        //- Footer
        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click.prevent="closeModal()") Cancel
                button.btn.btn--medium.btn--round.btn-rev(
                    :class="{'ui-disabled' : saveButtonIsDisabled}"
                    @click.prevent="saveConnection()") {{ formAction }} Connection


</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { cloneDeep, filter, isNil } from 'lodash'

import { DEM_CONNECTION_FORM_DATA, DEM_CONNECTION_FORM_TYPES } from '@/utils/constants'
import ScreenLockLoader from '@/components/common/ScreenLockLoader'

export default {
    name: 'FormConnection',

    components: {
        ScreenLockLoader
    },

    props: {
        dataForm: { type: Object, required: true },
        closeModal: { type: Function, required: true }
    },

    data() {
        return {
            attemptCounter: 0,
            optionConnections: cloneDeep(DEM_CONNECTION_FORM_TYPES),
            dataFormConnection: cloneDeep(this.dataForm),
            displayPassword: false,
        }
    },

    computed: {
        // Call to state
        ...mapState('ui/dataEntry', {
            connectionId: state => state.connectionId,
            formAction: state => state.formAction,
            formIsValid: state => state.formIsValid.connection
        }),
        // Call to getters
        ...mapGetters('data/dataEntry', ['getConnectionList']),
        ...mapGetters('ui/dataEntry', ['notReadyIsLoading']),

        connectionsList() {
            return filter(this.getConnectionList(), item => item.status === 'active')
        },

        // Naming for template
        hostnameTitle() {
            return this.dataFormConnection.type === 's3' || this.dataFormConnection.type === 'gcloud' ? 'Bucket name' : 'Hostname'
        },
        hostnamePlaceholder() {
            return this.dataFormConnection.type === 's3' || this.dataFormConnection.type === 'gcloud' ? 'Bucket name' : 'IP address or URL'
        },
        username() {
            return this.dataFormConnection.type === 's3' ? 'Access key id' : 'Username'
        },
        password() {
            return this.dataFormConnection.type === 's3' ? 'Secret access key' : 'Password'
        },

        // UI
        buttonIsDisabled() {
            return this.dataFormConnection.id === null
        },
        passwordType() {
            return this.displayPassword ? 'text' : 'password'
        },
        passwordRequired() {
            return this.formAction === 'create'
        },
        isSftpKey() {
            return this.dataFormConnection.type === 'sftp' && this.dataFormConnection.sftpType === 'sftp_key'
        },
        sendPasswordToApi() {
            return this.formAction === 'create' || (this.formAction === 'edit' && !this.isSftpKey && !isNil(this.dataFormConnection.password))
        },
        sendConnectorKeyToApi() {
            return this.formAction === 'create' || (this.formAction === 'edit' && this.isSftpKey && !isNil(this.dataFormConnection.connector_key))
        },
        passwordRules() {
            return this.passwordRequired ? 'max:255|required' : 'max:255'
        },
        classPasswordRequest() {
            return this.passwordRequired ? 'form-label__required' : 'form-label'
        },
        saveButtonIsDisabled() {
            const commonDisable = this.errors.items.length > 0 || this.dataFormConnection.label === ''
            let specificDisable
            if (this.dataFormConnection.type === 'ftp' || (this.dataFormConnection.type === 'sftp' && this.dataFormConnection.sftpType === 'sftp_pwd')) {
                specificDisable =
                    this.dataFormConnection.hostname === '' ||
                    this.dataFormConnection.port === '' ||
                    this.dataFormConnection.username === '' ||
                    this.dataFormConnection.password === ''
            } else if (this.dataFormConnection.type === 'sftp' && this.dataFormConnection.sftpType === 'sftp_key') {
                specificDisable =
                    this.dataFormConnection.hostname === '' ||
                    this.dataFormConnection.port === '' ||
                    this.dataFormConnection.username === '' ||
                    this.dataFormConnection.connector_key === ''
            } else if (this.dataFormConnection.type === 's3') {
                specificDisable = this.dataFormConnection.hostname === '' || this.dataFormConnection.region === '' || this.dataFormConnection.username === ''
            } else if (this.dataFormConnection.type === 'gcloud') {
                specificDisable = this.dataFormConnection.hostname === ''
            }
            return commonDisable || specificDisable
        }
    },

    methods: {
        // Call to actions
        ...mapActions('data/dataEntry', ['createConnection', 'updateItem']),
        // Call to mutations
        ...mapMutations('ui/dataEntry', ['setConnectionId', 'setFormIsValid', 'setNextStep', 'setNotReadyIsLoading']),

        chooseConnection() {
            this.setConnectionId({ id: this.dataFormConnection.id })
            // Reset validation for next step
            this.setFormIsValid({
                type: 'all',
                valid: false
            })
            this.setFormIsValid({
                type: 'connection',
                valid: true
            })
            this.setNextStep()
        },

        displayFormConnection() {
            // Set a temporary id to display form connection
            this.setConnectionId({ id: 0 })
            this.setFormIsValid({
                type: 'all',
                valid: false
            })
        },
        saveConnection() {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        const newConnection = {
                            label: this.dataFormConnection.label,
                            type: this.dataFormConnection.type === 'sftp' ? this.dataFormConnection.sftpType : this.dataFormConnection.type,
                            hostname: this.dataFormConnection.hostname
                        }
                        if (this.formAction === 'edit') {
                            newConnection.id = this.dataFormConnection.id
                        }

                        if (newConnection.type !== 'gcloud') {
                            newConnection.username = this.dataFormConnection.username
                        }
                        if (newConnection.type === 's3') {
                            newConnection.region = this.dataFormConnection.region
                            if (this.sendPasswordToApi) {
                                newConnection.connector_key = this.dataFormConnection.password
                            }
                        } else if (newConnection.type === 'sftp_key') {
                            newConnection.port = this.dataFormConnection.port
                            if (this.sendConnectorKeyToApi) {
                                newConnection.connector_key = this.dataFormConnection.connector_key
                            }
                        } else if (newConnection.type === 'sftp_pwd') {
                            newConnection.port = this.dataFormConnection.port
                            if (this.sendPasswordToApi) {
                                newConnection.password = this.dataFormConnection.password
                            }
                        } else if (newConnection.type === 'ftp') {
                            newConnection.port = this.dataFormConnection.port
                            if (this.sendPasswordToApi) {
                                newConnection.password = this.dataFormConnection.password
                            }
                        }

                        if (this.formAction === 'create') {
                            this.createConnection({
                                newConnection,
                                firstCreateAttempt: this.attemptCounter++ < 1,
                                onFinish: async status => {
                                    this.setNotReadyIsLoading({ isLoading: status === 'NOT_READY' })
                                    return status === 'NOT_READY'
                                }
                            })
                                .then(() => {
                                    this.setFormConnection({ formConnection: cloneDeep(DEM_CONNECTION_FORM_DATA) })
                                })
                                .catch(() => {})
                        } else {
                            this.updateItem({
                                item: newConnection,
                                dataType: 'connection',
                                isCreation: false,
                                onFinish: status => {
                                    this.setNotReadyIsLoading({ isLoading: status === 'NOT_READY' })
                                    return status === 'NOT_READY'
                                }
                            }).catch(() => {})
                        }
                    }
                })
                .catch(() => {
                    // console.error('invalid form', error)
                    //this.closeFormTransfer()
                })
        }
    }
}
</script>
